import type { UserRepository } from '../repositories/user_repository'

export class DeleteUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
